module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/paidui_infobanner02.bea410b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc/product_info/paidui_infobanner02.png
// module id = oSWp
// module chunks = 0